import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Regular from "./noto-sans-latin-500-normal.woff2";

export const NotoSansRegularFontFaces: ExcalidrawFontFaceDescriptor[] = [
  { uri: Regular },
];
